import { isNil } from 'ramda';

export class Degree {
  private value?: number;
  private constructor(value?: number) {
    this.value = value;
  }

  static fromFloat(value?: number) {
    return new Degree(value);
  }

  toString() {
    return !isNil(this.value) ? `${this.value.toFixed(2)}` : 'N/A';
  }
}
